export enum SortOptions {
  Ascending = "ascending",
  Descending = "descending",
}
